// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-fields-overview {\n  padding: 4em;\n  width: 66.7%;\n  margin: 0 auto;\n  min-width: 800px;\n}\n", ""]);
// Exports
module.exports = exports;
